export const defaultRemoteConfig = {
  disableSignWithECP: false,
};
